<template>
  <a-layout-content class="p-all overflow-hidden">
    <a-card class="h-full d-flex flex-column nowrap">
      <span slot="title">Karyawan Baru</span>
      <a-steps class="steps-list" :current="current" status="process">
        <!-- <a-step title="Family Member" /> -->
        <a-step title="Profile" />
        <a-step title="Document" />
        <a-step title="Employee" v-if="!tlc" />
        <a-step title="Family Member" />
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component :is="steps[current].content" :data="data" :mode="mode" :ref="stepRef"></component>
        </keep-alive>
      </div>
      <template slot="actions">
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
          <a-button
            :loading="btnLoading"
            v-if="current == steps.length - 1"
            type="primary"
            @click="validate"
          >Save</a-button>
          <a-button v-if="current>0" @click="prev">Previous</a-button>
        </div>
      </template>
    </a-card>
  </a-layout-content>
</template>

<script>
import Profile from "./steps/Profile";
import Document from "./steps/Document";
import Employee from "./steps/Employee";
import Member from "./steps/Member";

import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "createKaryawan",
  props: ["tlc"],
  components: {
    Profile,
    Document,
    Employee,
    Member
  },
  data() {
    return {
      current: 0,
      btnLoading: false,
      steps: [],
      dataContainer: {},
      data: [],
      mode: "create"
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    stepRef: function() {
      let ref = "";
      if (this.mode == "create") {
        if (this.steps[this.current].content === "Profile") {
          ref = "refProfile";
        } else if (this.steps[this.current].content === "Document") {
          ref = "refDocument";
        } else if (this.steps[this.current].content === "Employee") {
          ref = "refEmployee";
        } else if (this.steps[this.current].content === "Member") {
          ref = "refMember";
        }
      } else {
        if (this.steps[this.current].content === "Profile") {
          ref = "refProfile";
        } else if (this.steps[this.current].content === "Document") {
          ref = "refDocument";
        } 
        // else if (this.steps[this.current].content === "Member") {
        //   ref = "refMember";
        // }
      }

      return ref;
    }
  },
  created() {
    if (this.tlc) {
      this.Fetch_EditedId();
      this.mode = "edit";
      this.steps = [
        {
          title: "Profile",
          content: "Profile"
        },
        {
          title: "Document",
          content: "Document"
        }
      ];
    } else {
      this.steps = [
        {
          title: "Profile",
          content: "Profile"
        },
        {
          title: "Document",
          content: "Document"
        },
        {
          title: "Employee",
          content: "Employee"
        },
        {
          title: "Family Member",
          content: "Member"
        },
        
      ];
    }
  },
  methods: {
    moment,
    next() {
      if (this.mode == "create") {
        if (this.steps[this.current].content === "Profile") {
          this.$refs.refProfile.handleRef();
        } else if (this.steps[this.current].content === "Document") {
          this.$refs.refDocument.handleRef();
        } else if (this.steps[this.current].content === "Employee") {
          this.$refs.refEmployee.handleRef();
        } else if (this.steps[this.current].content === "Member") {
          this.$refs.refMember.handleRef();
        }
      } else {
        if (this.steps[this.current].content === "Profile") {
          this.$refs.refProfile.handleRef();
        }
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      if (this.mode == "create") {
        // this.$refs.refEmployee.handleRef();
        this.$refs.refMember.handleRef();
      } else {
        this.$refs.refDocument.handleRef();
      }
    },
    submit() {
      this.btnLoading = true;
      let postData = new FormData();

      postData.append("nik", this.dataContainer.profile.nik);
      postData.append("tlc", this.dataContainer.profile.tlc);
      postData.append("nama", this.dataContainer.profile.nama);
      postData.append("no_ktp", this.dataContainer.profile.no_ktp);
      postData.append("alamat", this.dataContainer.profile.alamat);
      postData.append("telpon", this.dataContainer.profile.telpon);
      postData.append("tempat_lahir", this.dataContainer.profile.tempat_lahir);
      postData.append("tgl_lahir", this.dataContainer.profile.tgl_lahir.format(this.getStandartFormatDate));
      postData.append("gender", this.dataContainer.profile.gender);
      postData.append("status_perkawinan", this.dataContainer.profile.status_perkawinan);
      postData.append("agama", this.dataContainer.profile.agama);
      postData.append("email", this.dataContainer.profile.email);
      postData.append("tanggungan", this.dataContainer.profile.tanggungan);
      postData.append("no_ijazah", this.dataContainer.document.no_ijazah);
      postData.append("asal_univ", this.dataContainer.document.asal_univ);
      postData.append("thn_lulus", this.dataContainer.document.thn_lulus);
      postData.append("pendidikan_akhir",this.dataContainer.document.pendidikan_akhir);
      postData.append("npwp", this.dataContainer.document.npwp);
      postData.append("no_kpj", this.dataContainer.document.no_kpj);
      postData.append("no_bpjs", this.dataContainer.document.no_bpjs);
      if (this.mode === "create") {
        postData.append("foto", this.dataContainer.profile.foto[0]);
        postData.append(
          "tglmasuk",
          this.dataContainer.employee.tglmasuk.format(
            this.getStandartFormatDate
          )
        );
        postData.append("sts_karyawan", this.dataContainer.employee.sts_karyawan);
        postData.append("site", this.dataContainer.employee.site);
        // postData.append("jabatan", this.dataContainer.employee.jabatan);
        postData.append("id_dept", this.dataContainer.employee.id_dept || 0);
        postData.append("divisi", this.dataContainer.employee.divisi || "-");
        postData.append("golongan", this.dataContainer.employee.golongan);
        postData.append("kategori", this.dataContainer.employee.kategori || "-");
        postData.append("atasan", this.dataContainer.employee.atasan || "-");
        postData.append("no_rek", this.dataContainer.employee.no_rek || "-");
        postData.append("bank", this.dataContainer.employee.bank || "-");
      }

      postData.append("posisi", this.dataContainer.employee.nama_jabatan);
      postData.append("id_jabatan", this.dataContainer.employee.posisi);

      if(this.dataContainer.employee.grade)
      postData.append("id_pangkat", this.dataContainer.employee.grade);
      postData.append("career_path", this.dataContainer.employee.career_path);
      postData.append("work_hours", this.dataContainer.employee.work_hours);

      postData.append("member", JSON.stringify(this.dataContainer.member));

      let url = "";
      if (this.mode == "create") {
        url = this.$serviceUrl + "master_karyawan";
      } else {
        url = this.$serviceUrl + "master_karyawan/edit";
      }

      axios({
        method: "post",
        url: url,
        processData: false,
        data: postData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.displayMessage("success-edit");
          this.btnLoading = false;
          this.$router.go(-1);
        })
        .catch(err => {
          this.btnLoading = false;
          console.log(err);
          
        });
    },
    dataBucket(value) {
      if (this.steps[this.current].content === "Profile") {
        this.dataContainer.profile = value;
        this.current++;
      } else if (this.steps[this.current].content === "Document") {
        this.dataContainer.document = value;
        if (this.mode == "create") {
          this.current++;
        } else {
          this.confirmMessage("confirm-edit");
        }
      } else if (this.steps[this.current].content === "Employee") {
        this.dataContainer.employee = value;
        this.current++;
        // this.confirmMessage("confirm-save");
      } else if (this.steps[this.current].content === "Member") {
        this.dataContainer.member = value;
        this.confirmMessage("confirm-save");
      }
    },
    async Fetch_EditedId() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "master_karyawan/detail_edit",
        params: {
          tlc: this.tlc,
          "X-API-KEY": this.getAuth.apikey
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.data = response.data;
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  },
  mounted() {
    if (this.tlc) {
      this.Fetch_EditedId();
      this.mode = "edit";
    }

    Event.$on("createKaryawan", this.dataBucket);
    Event.$on("confirmMessageEdit", this.submit);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("createKaryawan", this.dataBucket);
    Event.$off("confirmMessageEdit", this.submit);
    Event.$off("confirmMessageReturn", this.submit);
  }
};
</script>

<style>
</style>
